<template>
    <a-modal
        title="上传员工"
        :visible="visible"
        class="modal-initialize"
        :width="570"
        :confirm-loading="confirmLoading"
        @cancel="closeModal"
        @ok="sendData"
    >
        <div class="bomb-remind">
            <div class="bomb-form">
                <div class="import-tips">
                    <a-alert type="info">
                        <p slot="message">导入说明：请下载<a href="javascript:void(0);" @click="download">{{ tpltitle }}</a>，按模板提示修改本地文件后再上传文件。
                        </p>
                    </a-alert>
                </div>
                <div class="import-content-column bomb-import-file">
                    <div class="import-content-list">
                        <div class="content-select">
                            <a-upload :multiple="false" :beforeUpload="beforeUpload" :fileList="fileList"
                                      @change="handleChangeFile">
                                <a-button>
                                    <a-icon type="upload"/>
                                    上传文件
                                </a-button>
                            </a-upload>
                            <div class="content-remind">
                                <p>一次最多上传2000行，超出部分请分次上传。</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--导入结果-->
        <exportRes
            :visible="showModalExportRes"
            :thead="exportData.thead"
            :error_data="exportData.error_data"
            :success_num="exportData.success_num"
            :error_num="exportData.error_num"
            @changeModal="changeModal"
        >
        </exportRes>
    </a-modal>
</template>

<script>
// import {Alert, Upload, Button, Icon} from "ant-design-vue";
import exportRes from '@/components/modal/uploadResult';

export default {
    components: {
        exportRes,
        // [Alert.name]: Alert,
        // [Upload.name]: Upload,
        // [Button.name]: Button,
        // [Icon.name]: Icon,
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        sbid: {
            type: String,
            default: ''
        },
        tplinfo: {// 模板
            type: Array,
            default: []
        },
    },
    data() {
        return {
            confirmLoading: false,
            showModal: this.visible,
            showModalExportRes: false,// 导出结果
            formItemLayout: {
                labelCol: {
                    span: 5
                },
                wrapperCol: {
                    span: 19
                },
            },
            fileList: [],
            exportData: {
                thead: [],
                error_data: [],
                success_num: 0,
                error_num: 0,
            },
            tpltitle: '员工工资条模板',
        };
    },
    watch: {
        // 实现双向绑定
        visible(val) {
            this.showModal = val;

            if (val === false) {
                this.fileList = [];
            } else {
                this.getData();
            }
        },
        showModal(val) {
            this.$emit("changeModal", val);
        },
    },
    model: {
        prop: 'visible',
        // 这个事件名可以随意写，它实际上是规定了子组件要更新父组件值需要注册的方法
        event: 'changeVisible'
    },
    methods: {
        closeModal() {
            this.$emit('changeVisible', false);
        },
        getData() {
            console.log(this.said)
        },
        sendData() {
            if (this.fileList.length === 0) {
                this.commonFun.alert({content: '请上传文件'});
                return false;
            }

            // 操作中
            this.confirmLoading = true;

            let that = this;
            let reader = new FileReader();
            reader.readAsDataURL(this.fileList[0].originFileObj);
            //FileReader的onload句柄绑定回调函数
            reader.onload = function () {
                let data = {};
                let url = '';
                let filedata = this.result.split(',')[1];

                url = '/manage/salary/import';
                data.sbid = that.sbid;
                // console.log(data);
                data.filedata = filedata;

                that.http(url, data, (res) => {
                    that.showModalExportRes = true;
                    that.exportData.thead = res.info.header;
                    that.exportData.error_data = res.info.errordata;
                    that.exportData.error_num = res.info.error;
                    that.exportData.success_num = res.info.success;

                    that.confirmLoading = false;
                    that.closeModal();
                }, (res) => {
                    that.confirmLoading = false;
                });
            };
        },
        beforeUpload(file) {
            return false;
        },
        handleChangeFile(e) {
            if (Array.isArray(e)) {
                this.fileList = e;
                return e;
            }

            // 只允许上传一个文件
            if (e.fileList) {
                let len = e.fileList.length;
                if (len >= 1) {
                    e.fileList = [e.fileList[len - 1]];
                }
            }
            this.fileList = e.fileList;
        },
        download() {
            require.ensure([], () => {
                const {export_json_to_excel} = require('../../assets/excel/Export2Excel');

                let data = [];
                let merge = [{"s": {"r": 0, "c": 0}, "e": {"r": 0, "c": this.tplinfo.length - 1}}];
                let style = {
                    'A1': {alignment: {vertical: 'center', horizontal: 'left'}}
                };

                // 必填项标红
                let s = 'A';
                let sty = {font: {color: {rgb: 'FF0000'}}};

                for (let i in this.tplinfo) {
                    data.push(this.tplinfo[i][0]);

                    // 必填项标红
                    if (this.tplinfo[i][1] == '1') {
                        let st = s + '2';
                        style[st] = sty;
                    }
                    let code = s.charCodeAt(0);
                    s = String.fromCharCode(code + 1);
                }

                console.log(style)

                let title = "姓名、手机、身份证为必填项\n员工可查：为1时，工资可查；否则，工资不可查。\n增加项请在列表后方添加，如：应发工资、实发工资等"
                let thead = [title];

                export_json_to_excel(thead, [data], this.tpltitle, merge, style);
            })
        },
        changeModal(e) {
            this.showModalExportRes = e;

            if (e === false) {
                this.$emit("confirm");
            }
        }
    }
}
</script>
<style lang="less">
.content-select {
    text-align: center;
    padding: 40px 0;

    .content-remind {
        padding-top: 20px;

        p {
            font-size: 12px;
            color: #999;
        }
    }
}
</style>
